import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/app/(public)/[sport]/players/[id]/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/game/card/detailed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/primitives/back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/team/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameProvider"] */ "/Users/joseph/projects/moneyline/client/src/utils/providers/game.tsx");
